module.exports = __webpack_public_path__ + "static/img/t1.94d4d2f4.png";